/* eslint-disable react/jsx-no-undef */
import { React, useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../../../navigation/Auth/auth";
import { Button, Grid, TextField } from "@material-ui/core";
import axios from "axios";
import Cookies from "js-cookie";
import * as sweetalert from "sweetalert";
import packageJson from "../../../../package.json";
import Controls from "../global/controls/Controls";
import { useForm } from "./useForm";
// import firebase  from "../../../firebasese";

import ConfirmDialog from "./ConfirmDialog";
import firebase from "../../../firebasese";
import { messaging } from "../../../firebasese";
import { getToken } from "firebase/messaging";
import { PrivcePoliceAccept } from "./privcepoliceAccept";
import PopupCreate from "../global/PopupCreate";
import { getConfigMode } from "../../../services/ConfigMode";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [login_information, setLogin_information] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);

  const auth = useAuth();
  const [Config, setConfig] = useState("");

    useEffect(() => {
     
      getConfigMode()
        .then((res) => {
          setConfig(res.data.maintenance_mode);
      
        })
        .catch((err) => {
          setConfig();
  
        });
  
    
  
      return () => {};
    }, []);
    const staff_type = localStorage.getItem('staff_type');
    useEffect(() => {},[staff_type,Config]);
  const redirectPath = location.state?.path || (Config == 1  && staff_type !== 'Admin') ?( "/maintenance"):( "/dashboard");
  const initialFValues = {
    mobile_number: "",
    password: "",
    auth: "",
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };
    temp.mobile_number = fieldValues.mobile_number ? "" : "رقم الهاتف مطلوب";

    if (fieldValues.mobile_number) {
      if (!/^[0-9]+$/.test(fieldValues.mobile_number)) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل أرقام فقط";
      } else if (fieldValues.mobile_number.length !== 10) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل 10 أرقام";
      }
    }

    temp.password = fieldValues.password ? "" : "كلمة السر مطلوبة";

    if (fieldValues.password) {
      if (fieldValues.password.length < 8) {
        temp.password = "يجب أن تكون كلمة السر على الأقل 8 أحرف";
      }
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === loginInput) {
      return Object.values(temp).every((x) => x === "");
    }
  };

  const handeleInput = (e) => {
    e.persist();
    setLogin({
      ...loginInput,
      [e.target.name]: e.target.value,
    });
  };
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [FCM, setFcm] = useState("");

  useEffect(() => {
    const requestNotificationPermission = async () => {
      try {
        const permission = await Notification.requestPermission();

        if (permission === "granted") {
          // Permission granted, now get the FCM token.
          const data = await getToken(messaging);
          setFcm(data);
        } else {
          // Permission denied or dismissed by the user.
          // Handle the situation as needed.
          throw new Error("Permission denied for notifications.");
        }
      } catch (error) {
        // Handle any errors that occurred during permission request or token retrieval.
        console.error("Failed to get permission or token:", error);
      }
    };

    requestNotificationPermission();
  }, [FCM]);

  const loginSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
  
      const data = {
        mobile_number: loginInput.mobile_number,
        password: loginInput.password,
       
      };

      axios
        .post(`${BaseUrl}/api/mobile/login`, data, {
          withCredentials: true,
        })
        .then((res) => {
          setLogin_information(res.data.data);
          if (res.data.status === true) {
            // if (res.data.data.login_information.is_agree === 0) {
            //   navigate("/privce-police");
            //   localStorage.setItem("is loggedIn", true);
            // }
            // if (res.data.data.login_information.is_agree === 1) {
              setLoading(false);
              localStorage.setItem("is loggedIn", true);
              localStorage.setItem("staff_type", res.data.data.staff_type);
              localStorage.setItem("mobile_number_login", res.data.data.mobile_number);
              const locale = localStorage.getItem("is loggedIn");
              const user = locale;
              auth.login(user);

              sweetalert("تم تسجيل الدخول بنجاح", {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                navigate(location.state?.path || (Config == 1  && res.data.data.staff_type != 'Admin') ?( "/maintenance"):( "/dashboard"), { replace: true });
                const token = { token: FCM };
                axios
                  .post(`${BaseUrl}/api/updateDeviceToken`, token, {
                    withCredentials: true,
                  })
                  .then((res) => {
                  });
              });
            } else {
              setLoading(false);
              sweetalert(res.data.msg);
              setLogin({ ...loginInput, error_list: res.data.error });
            }
          // }
        }).catch(error => {
          if (error.response && error.response.status === 410) {
            sweetalert("الموقع قيد الصيانة سيتم تفعيل الموقع في وقت قريب", {
              icon: "error"
            });
            // Optionally navigate the user to another page
            navigate("/maintenance");
          } else {
            sweetalert("An error occurred. Please try again later.", {
              icon: "error"
            });
            console.error("Login error:", error.response || error);
          }
        });
    }
  };

  const { loginInput, setLogin, errors, setErrors } = useForm(
    initialFValues,
    true,
    validate
  );

  return (
    <div>
      <form className="form-group" onSubmit={loginSubmit}>
        <Grid container style={{ minHeight: "100vh" }}>
          <Grid item className="home-item" xs={12} sm={6}>
            <h1 style={{ textAlign: "center" }}>ليرتنا كاش</h1>
            <p>
              {" "}
              صمم هذا التطبيق ليكون أداة مساعدة لمراكز تعبئة الرصيد في سوريا،
              فهو مخصص لتحويل الوحدات و تسديد الفواتير لشبكتي سيرياتل و ام تي ان
              بسهولة بالغة، يقدم إمكانية إدارة موزعين الجملة و مراكز الخدمة في
              مختلف المحافظات و المناطق مع إمكانية حفظ الزبائن في قاعدة البيانات
              و بالتالي يمكن التحويل للعميل من خلال اختيار اسمه وتحديد كمية
              الوحدات فقط، كما أنه يمكن حفظ نسخة من التقارير بأنواعها المختلفة
              ضمن سجل خاص{" "}
            </p>
            <img src="hom.svg" alt="login-img" />
          </Grid>
          <Grid
            container
            item
            alignItems="center"
            direction="column"
            justify="center"
            xs={12}
            sm={6}
            style={{ padding: 10 }}
          >
            <div>
              <h2 className="title-home">مرحبا</h2>
              <h2 className="title-home">سجل دخول إلى حسابك</h2>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Controls.Input
                label="رقم الهاتف"
                name="mobile_number"
                fullWidth
                onChange={handeleInput}
                className="form-control"
                error={errors.mobile_number}
                type="text"
              />
              <Controls.Input
                label="كلمة المرور"
                type="password"
                fullWidth
                name="password"
                onChange={handeleInput}
                className="form-control"
                error={errors.password}
              />
              {/* <TextField
                className="form-control"
                variant="outlined"
                label="رقم الهاتف"
                fullWidth
                type="text"
                margin="normal"
                name="mobile_number"
                onChange={handeleInput}
                dir="rtl"
                value={loginInput.mobile_number}
                error={!!loginInput.mobile_numberError}
                helperText={loginInput.mobile_numberError}
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },

                  "& .MuiOutlinedInput-root": {
                    fontSize: "1rem",
                    direction: "rtl !important",
                  },
                }}
              /> */}
              {/* <TextField
                className="form-control"
                variant="outlined"
                fullWidth
                label="كلمة المرور"
                type="password"
                name="password"
                onChange={handeleInput}
                value={loginInput.password}
                error={!!loginInput.error_list.length}
                helperText={loginInput.error_list.join(", ")}
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },

                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              /> */}
              <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
              />
              {loading === true ? (
                <>
                  <Controls.Button
                    text=<div class="spinner center">
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                    </div>
                    variant="contained"
                    className="btn-submit resend-code"
                  ></Controls.Button>
                </>
              ) : (
                <>
                  <Controls.Button
                    type="submit"
                    onClick={loginSubmit}
                    text="تسجيل الدخول"
                    variant="contained"
                    className="btn-submit"
                  ></Controls.Button>
                </>
              )}

              <Link
                style={{ textAlign: "right" }}
                to={{
                  pathname: "/forget-password",

                  state: { fromDashboard: true },
                }}
              >
                هل نسيت كلمة المرور؟
              </Link>
              <a
              href='#'
                style={{ textAlign: "right" , marginTop:'4%'}}
                onClick={() => {
                setOpenPopup(true);
             
              }}
              >
              سياسة الخصوصية
              </a>
              <PopupCreate
          title="سياسة الخصوصية"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <PrivcePoliceAccept/>
        </PopupCreate>
            </div>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};
